<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="数值设置" name="number">
        <el-form ref="form" label-width="100px">
          <!-- 换算率小数位 -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="换算率小数位">
                <el-select v-model="Iinvexchrate" @change="changeNumericSetting">
                  <el-option v-for="i in 9" :key="i - 1" :value="i - 1" :label="i - 1" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 数量小数位 -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="数量小数位">
                <el-select v-model="Quantity" @change="changeNumericSetting">
                  <el-option v-for="i in 9" :key="i - 1" :value="i - 1" :label="i - 1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="zero">
                <el-checkbox v-model="IsQuantityRounding" @change="changeNumericSetting">舍零</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- 单价整数位 -->
            <el-col :span="8">
              <el-form-item label="单价整数位">
                <el-select v-model="UnitPrice" @change="changeNumericSetting">
                  <el-option v-for="i in 9" :key="i" :value="i" :label="i" />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 单价小数位 -->
            <el-col :span="8">
              <el-form-item label="单价小数位">
                <el-select v-model="UnitPriceDecimals" @change="changeNumericSetting">
                  <el-option v-for="i in 8" :key="i - 1" :value="i - 1" :label="i - 1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="zero">
                <el-checkbox v-model="IsUnitPriceRounding" @change="changeNumericSetting">舍零</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="生产设置" name="product">
        <el-form ref="form" label-width="85px">
          <!-- 快捷流程 -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="快捷流程">
                <template slot="label">
                  <span>
                    <span>快捷流程</span>
                    <el-popover placement="top" width="400" trigger="hover" content="快捷流程选“是”时，省去排产、报工、质检等流程">
                      <i slot="reference" class="el-icon-question"></i>
                    </el-popover>
                  </span>
                </template>

                <el-select v-model="QuickProcess" @change="changeProductSetting">
                  <el-option :value="false" label="否"></el-option>
                  <el-option :value="true" label="是"></el-option>
                </el-select>
              </el-form-item>
            </el-col> </el-row
          ><!-- 快捷流程 -->
          <!-- 是否需要生成领料单 -->
          <!-- <el-row>
            <el-col :span="12">
              <el-form-item label-width="140px" label="是否需要生成领料单">
                <template slot="label">
                  <span>
                    <span>是否需要生成领料单</span>
                  </span>
                </template>

                <el-select
                  v-model="IsNeedGetDoc"
                  @change="changeIsNeedGetDoc"
                >
                  <el-option :value="false" label="否"></el-option>
                  <el-option :value="true" label="是"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- 是否需要生成领料单 -->

          <!-- 需求重量单位 -->
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="140px" label="需求重量单位">
                <template slot="label">
                  <span>
                    <span>需求重量单位</span>
                  </span>
                </template>

                <el-select v-model="NeedUnit" @change="changeNeedUnit">
                  <el-option value="斤" label="斤"></el-option>
                  <el-option value="公斤" label="公斤"></el-option>
                </el-select>
              </el-form-item>
            </el-col> </el-row
          ><!-- 需求重量单位 -->
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="销售设置" name="sale">
        <el-form ref="form" label-width="160px">
          <!-- 销货单选单 -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="销货单选单">
                <template slot="label">
                  <span>
                    <span>销货单选单</span>
                    <el-popover placement="top" width="260" trigger="hover" content="是否要发货通知单才能做销货单">
                      <i slot="reference" class="el-icon-question"></i>
                    </el-popover>
                  </span>
                </template>
                <el-select v-model="SalesSeleted" @change="changeSaleSetting">
                  <el-option :value="0" label="正常"></el-option>
                  <el-option :value="1" label="发货通知单"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="销货单审核校验负库存">
                <template slot="label">
                  <span>
                    <span>销货单审核校验负库存</span>
                  </span>
                </template>
                <el-select v-model="SalesCheck" @change="changeSalesCheck">
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="销售出库是否检验收款">
                <template slot="label">
                  <span>
                    <span>销售出库是否检验收款</span>
                  </span>
                </template>
                <el-select v-model="ActivateFinance" @change="changeActivateFinance">
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="单据设置" name="bills">
        <el-form ref="form" label-width="100px">
          <!-- 默认查看天数 -->
          <el-row>
            <el-col :span="6">
              <el-form-item label="默认查看天数">
                <template slot="label">
                  <span> 默认查看天数 </span>
                </template>
                <el-input type="number" v-int v-model.number="SelectDay"></el-input>

                <!-- <el-select v-model="SalesSeleted" @change="changeSaleSetting">
                  <el-option :value="0" label="正常"></el-option>
                  <el-option :value="1" label="发货通知单"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button class="btn" type="primary" @click="changeDocSetting">确定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="采购设置" name="purchase">
        <el-form ref="form" label-width="160px">
          <!-- 采购需求生成单据 -->
          <el-row>
            <el-col :span="8">
              <el-form-item label="采购需求生成单据">
                <template slot="label">
                  <span>
                    <span>采购需求生成单据</span>
                  </span>
                </template>
                <el-select v-model="PurchaseCreateSeleted" @change="changePurchaseCreateSeleted">
                  <el-option :value="0" label="采购订单"></el-option>
                  <el-option :value="1" label="请购单"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="库存设置" name="stock">
        <el-form ref="form" label-width="240px">
          <!-- 销货单选单 -->
          <el-row>
            <!-- <el-col :span="8">
              <el-form-item label="采购(委外)入库单是否显示委外仓库">
                <template slot="label">
                  <span>
                    <span>采购(委外)入库单是否显示委外仓库</span>
                  </span>
                </template>
                <el-select v-model="PurchaseReceipt" @change="changePurchaseReceipt">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="初始设置" name="initial">
        <el-form ref="form" label-width="160px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否启用PDA">
                <template slot="label">
                  <span>
                    <span>是否启用PDA</span>
                  </span>
                </template>
                <el-select v-model="HasPDA" @change="changeInitialSetting">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="是否启用自制领料">
                <template slot="label">
                  <span>
                    <span>是否启用自制领料</span>
                  </span>
                </template>
                <el-select v-model="IsSelfPicking" @change="changeInitialSetting">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否启用委外领料">
                <template slot="label">
                  <span>
                    <span>是否启用委外领料</span>
                  </span>
                </template>
                <el-select v-model="IsOutPicking" @change="changeInitialSetting">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否启用不合格品库存">
                <template slot="label">
                  <span>
                    <span>是否启用不合格品库存</span>
                  </span>
                </template>
                <el-select v-model="IsUnqualifiedStock" @change="changeInitialSetting">
                  <el-option :value="true" label="是"></el-option>
                  <el-option :value="false" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="IsUnqualifiedStock">
            <el-col :span="6">
              <el-form-item label="不合格品标识">
                <template slot="label">
                  <span> 不合格品标识 </span>
                </template>
                <el-input type="text" v-model="UnqualifiedMark"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button class="btn" type="primary" @click="changeInitialSetting">确定</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="工单设置" name="workorder">
        <el-form ref="form" label-width="200px">
          <el-row>
            <el-col :span="1">
              <el-form-item label="模式">
                <template slot="label">
                  <span> 模式 </span>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <template>
                  <el-radio v-model="IssueIsApproval" @change="changeWorkorderSetting" :label="false">工单下达</el-radio>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <template>
                  <el-radio v-model="IssueIsApproval" @change="changeWorkorderSetting" :label="true">工单审批</el-radio>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="1">
              <el-form-item label="启用设备关联生产任务">
                <template slot="label">
                  <span> 启用设备关联生产任务 </span>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <template>
                  <el-radio v-model="IsAssociation" @change="changeWorkorderSetting" :label="false">不启用</el-radio>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <template>
                  <el-radio v-model="IsAssociation" @change="changeWorkorderSetting" :label="true">启用</el-radio>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'options',

  data() {
    return {
      api: require('@/api/sy/option').default,
      activeName: 'number',
      SelectDay: 0,
      Iinvexchrate: null,
      Quantity: null,
      UnitPrice: null,
      UnitPriceDecimals: null,
      QuickProcess: false,
      IsNeedGetDoc: false,
      SalesSeleted: 0,
      IsQuantityRounding: false,
      IsUnitPriceRounding: false,
      isTime: true,
      NeedUnit: '斤',
      NeedRate: 500,
      PurchaseCreateSeleted: null,
      PurchaseReceipt: false,
      HasPDA: false,
      IsSelfPicking: true,
      IsOutPicking: false,
      SalesCheck: 0,
      IssueIsApproval: false,
      ActivateFinance: 0,
      IsAssociation: false,
      IsUnqualifiedStock: false,
      UnqualifiedMark: null
    }
  },
  created() {
    this.getNumericSetting()
    this.getProductSetting()
    this.getSaleSetting()
    this.getDocSetting()
    this.getPurchaseSetting()
    this.getStockSetting()
    this.getInitialSetting()
    this.getSaleCheckSetting()
    this.getWorkorderSetting()
  },
  methods: {
    /** 销货单审核校验负库存  */
    getSaleCheckSetting() {
      this.api.getSaleCheckSetting().then(res => {
        if (res.Code === 0) {
          this.SalesCheck = res.Data.SalesCheck
        }
      })
    },
    getNumericSetting() {
      this.api.getNumericSetting().then(res => {
        if (res.Code === 0) {
          this.Iinvexchrate = res.Data.Iinvexchrate
          this.Quantity = res.Data.Quantity
          this.UnitPrice = res.Data.UnitPrice
          this.UnitPriceDecimals = res.Data.UnitPriceDecimals
          this.IsQuantityRounding = res.Data.IsQuantityRounding
          this.IsUnitPriceRounding = res.Data.IsUnitPriceRounding
        }
      })
    },
    getProductSetting() {
      this.$store.dispatch('getProductSetting').then(res => {
        this.QuickProcess = res.QuickProcess
        this.NeedUnit = res.NeedUnit
        this.NeedRate = res.NeedRate
        this.IsNeedGetDoc = res.IsNeedGetDoc
      })
      // this.api.getProductSetting().then((res) => {
      //   if (res.Code === 0) {

      //     localStorage.setItem('SET_QuickProcess', this.QuickProcess)
      //     localStorage.setItem('NeedUnit', this.NeedUnit)
      //     localStorage.setItem('NeedRate', this.NeedRate)
      //     localStorage.setItem('SET_IsNeedGetDoc', this.IsNeedGetDoc)

      //   }
      // });
    },
    getSaleSetting() {
      this.api.getSaleSetting().then(res => {
        if (res.Code === 0) {
          this.SalesSeleted = res.Data.SalesSeleted
          this.ActivateFinance = res.Data.ActivateFinance
        }
      })
    },
    getDocSetting() {
      this.api.getDocSetting().then(res => {
        if (res.Code === 0) {
          this.SelectDay = res.Data.SelectDay
        }
      })
    },
    getPurchaseSetting() {
      this.$store.dispatch('getPurchaseSetting').then(res => {
        this.PurchaseCreateSeleted = res.PurchaseCreateSeleted
      })
    },
    getStockSetting() {
      this.$store.dispatch('getStockSetting').then(res => {
        this.PurchaseReceipt = res.PurchaseReceipt
        console.log('this.PurchaseReceipt', this.PurchaseReceipt, typeof this.PurchaseReceipt)
      })
    },
    getWorkorderSetting() {
      this.$store.dispatch('getWorkDocSetting').then(res => {
        console.log('res', res.IssueIsApproval)
        this.IssueIsApproval = res.IssueIsApproval
        this.IsAssociation = res.IsAssociation
      })
    },
    changeWorkorderSetting(val) {
      console.log(val)
      this.api.workDocSettingSave({ IssueIsApproval: this.IssueIsApproval, IsAssociation: this.IsAssociation }).then(res => {
        if (res.Code === 0) {
          this.$message({
            type: 'success',
            message: res.Msg
          })
          this.getWorkorderSetting()
        } else {
          this.$message({
            type: 'warning',
            message: res.Msg
          })
        }
      })
    },
    getInitialSetting() {
      this.$store.dispatch('getInitialSetting').then(res => {
        this.HasPDA = res.HasPDA
        this.IsSelfPicking = res.IsSelfPicking
        this.IsOutPicking = res.IsOutPicking
        this.IsUnqualifiedStock = res.IsUnqualifiedStock
        this.UnqualifiedMark = res.UnqualifiedMark
        console.log('this.HasPDA', this.HasPDA, typeof this.HasPDA)
      })
    },
    changeInitialSetting() {
      this.api
        .initialSettingSave({
          HasPDA: this.HasPDA,
          IsSelfPicking: this.IsSelfPicking,
          IsOutPicking: this.IsOutPicking,
          IsUnqualifiedStock: this.IsUnqualifiedStock,
          UnqualifiedMark: this.IsUnqualifiedStock ? this.UnqualifiedMark : ''
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.getInitialSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changePurchaseReceipt() {
      this.api
        .stockSettingSave({
          PurchaseReceipt: this.PurchaseReceipt
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.getStockSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changePurchaseCreateSeleted() {
      this.api
        .purchaseSettingSave({
          PurchaseCreateSeleted: this.PurchaseCreateSeleted
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.getPurchaseSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changeNumericSetting() {
      this.api
        .numericSettingSave({
          Iinvexchrate: this.Iinvexchrate,
          Quantity: this.Quantity,
          IsQuantityRounding: this.IsQuantityRounding,
          UnitPrice: this.UnitPrice,
          UnitPriceDecimals: this.UnitPriceDecimals,
          IsUnitPriceRounding: this.IsUnitPriceRounding
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.$store.dispatch('getNumericSetting')
            this.getNumericSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changeNeedUnit(val) {
      this.NeedUnit = val
      if (this.NeedUnit === '斤') {
        this.NeedRate = 500
      } else {
        this.NeedRate = 1000
      }

      this.api
        .productSettingSave({
          QuickProcess: this.QuickProcess,
          IsNeedGetDoc: this.IsNeedGetDoc,
          NeedUnit: this.NeedUnit,
          NeedRate: this.NeedRate
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            // this.$store.dispatch("getProductSetting");
            this.getProductSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changeProductSetting() {
      this.api
        .productSettingSave({
          QuickProcess: this.QuickProcess,
          IsNeedGetDoc: this.IsNeedGetDoc,
          NeedUnit: this.NeedUnit,
          NeedRate: this.NeedRate
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.getProductSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changeIsNeedGetDoc() {
      this.api
        .productSettingSave({
          IsNeedGetDoc: this.IsNeedGetDoc,
          QuickProcess: this.QuickProcess,
          NeedUnit: this.NeedUnit,
          NeedRate: this.NeedRate
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            // this.$store.dispatch("getProductSetting");
            this.getProductSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changeSaleSetting() {
      this.api
        .saleSettingSave({
          SalesSeleted: this.SalesSeleted,
          ActivateFinance: this.ActivateFinance
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.$store.dispatch('getSaleSetting')
            this.getSaleSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changeActivateFinance() {
      this.api
        .saleSettingSave({
          SalesSeleted: this.SalesSeleted,
          ActivateFinance: this.ActivateFinance
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.$store.dispatch('getSaleSetting')
            this.getSaleSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    /** 切换销货单审核校验负库存  */
    changeSalesCheck() {
      this.api
        .saleCheckSettingSave({
          SalesCheck: this.SalesCheck
        })
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            this.$store.dispatch('getSaleCheckSetting')
            this.getSaleCheckSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    changeDocSetting() {
      this.api
        .docSettingSave({
          SelectDay: this.SelectDay
        })
        .then(res => {
          this.isTime = true
          if (res.Code === 0) {
            this.$message({
              type: 'success',
              message: res.Msg
            })
            // this.$store.dispatch("getSaleSetting");
            this.getDocSetting()
          } else {
            this.$message({
              type: 'warning',
              message: res.Msg
            })
          }
        })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    details(row) {
      this.$refs.detailDialog.openDetails(row)
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.RoleId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  margin-left: 10px;
}
.zero {
  display: flex;
  align-items: center;

  /deep/ .el-form-item__content {
    margin-left: 10px !important;
  }
}
</style>
